import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import eisenhowerSlice from "./eisenhowerSlice";

export const EisenhowerContext = React.createContext(null);

const eisenhowerStore = configureStore({
    reducer: {
        eisenhowerStore: eisenhowerSlice,
    },
});
export default eisenhowerStore;

export type State = ReturnType<typeof eisenhowerStore.getState>;
export type Dispatch = typeof eisenhowerStore.dispatch;
export const useEisenhowerSelector: TypedUseSelectorHook<State> = createSelectorHook(EisenhowerContext);
export const useEisenhowerDispatch = createDispatchHook<Dispatch>(EisenhowerContext);
